import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { HttpClientModule } from '@angular/common/http';
import { SidebarComponent } from './sidebar/sidebar.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { DateRangePickerModule } from '@syncfusion/ej2-angular-calendars';
import { WelcomeComponent } from './welcome/welcome.component';
import {UserModule} from './user/user.module';
import {CategoriesModule} from './categories/categories.module';
import {TechnicalApplicationsModule} from './technical-applications/technical-applications.module';
import { LogoutComponent } from './logout/logout.component';
import {DashboardsModule} from './dashboards/dashboards.module';
import {ProductsModule} from './products/products.module';
import {  HTTP_INTERCEPTORS } from '@angular/common/http';
import {AuthInterceptor} from './api/auth.interceptor';
@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    WelcomeComponent,
    LogoutComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    DateRangePickerModule,
    UserModule,
    CategoriesModule,
    TechnicalApplicationsModule,
    DashboardsModule,
    ProductsModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  entryComponents: [LogoutComponent]
})
export class AppModule { }
